export default "__VITE_ASSET__DTKMSktM__"